<app-spinner></app-spinner>
<div mat-flat-button class="formclose" align="right" (click)=" closeEntityForm()"><img src="assets/img/icons/forma-11.png"> </div>
<div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
    <div class="loginbox">
        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
            <form [formGroup]="Entity" class="example-form">
                <div class="fheader">Add Entity</div>
                <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12"></div>
                <div class="flabel">Name
                    <div>
                        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12"></div>
                        <div class="col-sm-12 col-xs-12 col-md-9 col-lg-9" style="padding-left: 0px">
                            <mat-form-field appearance="outline" class="example-full-width" style="width:100%">
                                <input (keypress)="handleInput($event)" class="content" placeholder="Enter the name" matInput formControlName="name" value="">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
               
                <div class="col-sm-12 col-xs-12 col-md-3 col-lg-3">
                                     <button [disabled]="!Entity.valid" mat-flat-button class="btn" (click)="createEntity()">Add</button>
                </div>
                <mat-error *ngIf="validator.UniqueEntity">{{validator.errorMessage}}</mat-error>
                
            </form>
        </div>
    </div>
</div>